import Vue from 'vue'
import App from './App.vue'
import router from './router'
import FishUI from 'fish-ui'
import Vuex from 'vuex';
import axios from 'axios';
import { Form, Spin, Popconfirm, Row, Col, Descriptions,Upload, Switch, Empty,Tooltip, Radio,Modal, Timeline, Divider, Alert, FormModel, Progress, Card, DatePicker, Pagination, Statistic, Button, Drawer, Tag, Menu, Icon, Dropdown, Badge, Table, Input, InputNumber, Select } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import vueHeadful from 'vue-headful';
import VueApexCharts from 'vue-apexcharts'
// Vue.mixin({
//   data: function() {
//     return {
//       get PRJ_START_DATE() {
//         return "2022-05-13 00:00:00";
//       }
//     }
//   }
// })
Vue.prototype.$PRJ_NAME = 'RCP3_LAGER'
Vue.prototype.$PRJ_START_DATE = '2026-04-01 00:00:00'
Vue.prototype.$PRJ_END_DATE = '2026-07-14 22:00:00'
Vue.prototype.$PRJ_DOMAIN = "https://chill.itcs.com.vn"
// Vue.prototype.$PRJ_PORT= '9082'
Vue.prototype.$PRJ_TOPUP_AMOUNT = [30000, 20000]
Vue.prototype.$PRJ_IS_30K = true
Vue.prototype.$PRJ_IS_20K = true
Vue.prototype.$PRJ_MAX_TOPUP = 210
Vue.prototype.$PRJ_DAY_TOPUP = 30
Vue.prototype.$PRJ_CODE_AMOUNT = 2010310 + 846012
Vue.prototype.$PRJ_TOTAL_AWARD = 2010310 * 30000 + 846012 * 20000

Vue.component('apexchart', VueApexCharts)
Vue.component('vue-headful', vueHeadful);
import SKProgress from 'vue-multiple-progress'
Vue.use(SKProgress)
Vue.use(Popconfirm);
Vue.use(Descriptions);
Vue.use(Empty);
Vue.use(Switch);
Vue.use(Upload);
Vue.use(Radio);
Vue.use(Modal);
Vue.use(Timeline);
Vue.use(Tooltip);
Vue.use(Alert);
Vue.use(Divider);
Vue.use(FormModel);
Vue.use(DatePicker);
Vue.use(Statistic);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(Card);
Vue.use(Drawer);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Menu);
Vue.use(Tag);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Table);
Vue.use(Badge);
Vue.use(Dropdown);
Vue.use(Progress);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Vuex);
// axios.defaults.baseURL = 'http://sbc1.itcs.com.vn'//'http://sbc1.itcs.com.vn'//
function GetContextUser(context) {
  if (!context) {
    return null;
  }

  // Vuex action
  if (
    context.state &&
    context.state.oUser
  ) {
    return context.state.oUser;
  }

  // Vue component
  if (
    context.$store &&
    context.$store.state &&
    context.$store.state.oUser
  ) {
    return context.$store.state.oUser;
  }

  return null;
}

function PrepareAPIData(context, Data) {
    let oData = Data || {};
    
    const oUser =
        GetContextUser(context);
    
    const sToken =
        oUser && oUser.Token ?
        oUser.Token :
        '';
    
    if (oData instanceof FormData) {
        if (
            sToken &&
            !oData.has('Token')
        ) {
            oData.append(
                'Token',
                sToken
            );
        }
        
        return oData;
    }
    
    if (sToken) {
        oData.Token = sToken;
    }
    
    return oData;
}
Vue.prototype.$PostAPI =
    function (
        APIPath,
        Data,
        Config
    ) {
        return PostAPI(
            this,
            APIPath,
            Data,
            Config
        );
    };

function PostAPI(
    context,
    APIPath,
    Data,
    Config
) {
    const oData =
        PrepareAPIData(
            context,
            Data
        );
    
    const oConfig =
        Object.assign({},
            Config || {}
        );
    
    /*
     * Option riêng của mình, không truyền xuống axios.
     */
    const ReturnResponse =
        oConfig.ReturnResponse === true;
    
    delete oConfig.ReturnResponse;
    
    return axios
        .post(
            Vue.prototype.$PRJ_DOMAIN +
            '/crm/api' +
            APIPath,
            oData,
            oConfig
        )
        .then(res => {
            return ReturnResponse ?
                res :
                res.data;
        });
}
// function PostAPI(context, APIPath, Data, Config) {
//   console.log(context)
//   const oData = PrepareAPIData(context, Data);

//   return new Promise((resolve, reject) => {
//     axios
//       .post(
//         Vue.prototype.$PRJ_DOMAIN + '/crm/api' + APIPath,
//         oData,
//         Config || {}
//       )
//       .then(res => {
//         resolve(res.data);
//       })
//       .catch(err => {
//         reject(err);
//       });
//   });
// }
// Vue.prototype.$PostAPI = PostAPI;
const store = new Vuex.Store({
  state: {
    $message: null,
    oUser: {},
    isLogin: false,
  },
  mutations: {
    Set_Message(state, val) {
      state.$message = val;
    },
    Set_isLogin(state, val) {
      val = (val == "true" || val) ? true : false
      state.isLogin = val;
      localStorage.setItem("isLogin", val);
      if (val == false) {
        state.oUser = {}
        localStorage.removeItem("oUser")
        localStorage.removeItem("isLogin")
      }
    },
    Set_oUser(state, { oUser }) {
      state.oUser = oUser;
      localStorage.setItem("oUser", JSON.stringify(state.oUser));
    },
  },
  getters: {
    isLogin: state => {
      if (localStorage.getItem("isLogin") == null || localStorage.getItem("oUser") == "false") {
        store.commit("Set_isLogin", false);
      }
      else {
        store.commit("Set_isLogin", localStorage.getItem("isLogin").toString() == "true");
      }
      return state.isLogin;
    },
    oUser: state => {
      try {
        if (localStorage.getItem("oUser") == null) {
          store.commit("Set_isLogin", false);
          localStorage.setItem("isLogin", false);

          store.commit("Set_oUser", {});
          localStorage.removeItem("oUser");
        }
        else {
          store.commit("Set_oUser", { oUser: JSON.parse(localStorage.getItem("oUser")) });
        }
      }
      catch (err) {
        console.log("Error when get oUser Main: " + err.message);
        store.commit("Set_oUser", {});
      }
      return state.oUser;
    },
    // getEventById: state => id => {
    //   return state.events.find(event => event.id === id);
    // },
    // events: state => {
    //   return state.events;
    // },
  },
  actions: {

    API_CRM_Entry_GetInfo(context, Data) {
      return PostAPI(
        context,
        '/entry/get-info',
        Data
      );
    },

    API_CRM_Entry_GetDetail(context, Data) {
      return PostAPI(
        context,
        '/entry/get-detail',
        Data
      );
    },

    API_CRM_Entry_GetLogs(context, Data) {
      return PostAPI(
        context,
        '/entry/get-logs',
        Data
      );
    },

    API_CRM_Entry_Update(context, Data) {
      return PostAPI(
        context,
        '/entry/update',
        Data
      );
    },

    API_CRM_Entry_VerifyImage(context, Data) {
      return PostAPI(
        context,
        '/entry/verify-image',
        Data
      );
    },

    API_CRM_Entry_UploadImage(context, Data) {
      return PostAPI(
        context,
        '/entry/upload-image',
        Data,
        {
          headers: {
            Authorization:
              'Bearer ' +
              context.state.oUser.Token
          }
        }
      );
    },

    API_CRM_Entry_Action(context, Data) {
      return PostAPI(
        context,
        '/entry/action',
        Data
      );
    },
    API_Login({ context }, oUserInfo) {
      return new Promise((resolve, reject) => {
        axios.post(Vue.prototype.$PRJ_DOMAIN + "/crm/api/login", {
          Username: oUserInfo.username,
          Password: oUserInfo.password,
        })
          .then(function (response) {
            //console.log(response);
            resolve(response.data)
          })
          .catch(function (error) {
            context.state.$message.error(
              "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
              3000, "bottom left"
            );
            reject(error)
            console.log(error);
          });
      });
    },
    API_Logout(context) {
      context.commit("Set_isLogin", false);
      context.dispatch("Go_Route", "/Login");
    },

    API_GetDashboard_Paytype(context, data) {
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/getdashboard_paytype', {
            "Time": data.time,
            "endDate": data.endDate,
            Token: context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              if (response.data.State == -1) {
                context.commit("Set_isLogin", false);
                this.$message.error(response.data.Message, 3000);
                context.dispatch("Go_Route", "/Login");
              } else resolve(response)
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              context.commit("Set_isLogin", false);
              context.dispatch("Go_Route", "/Login");
              reject(error)
              console.log(error);
            });
        });
    },
    API_GetDashboard(context, data) {
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/getdashboard', {
            "Time": data.time,
            Token: context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              if (response.data.State == -1) {
                context.commit("Set_isLogin", false);
                this.$message.error(response.data.Message, 3000);
                context.dispatch("Go_Route", "/Login");
              } else resolve(response)
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              context.commit("Set_isLogin", false);
              context.dispatch("Go_Route", "/Login");
              reject(error)
              console.log(error);
            });
        });
    },
    API_Getinfo(context) {
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/crm/api/getInfo", {
            Token: context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              if (response.data.State == -1) {
                context.commit("Set_isLogin", false);
                this.$message.error(response.data.Message, 3000);
                context.dispatch("Go_Route", "/Login");
              } else if (response.data.State == 1) {
                console.log("API_Getinfo", response.data)
                context.commit("Set_oUser", { oUser: response.data.Data.User });
                context.commit("Set_isLogin", true);
              }
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              context.commit("Set_isLogin", false);
              context.dispatch("Go_Route", "/Login");
              reject(error)
              console.log(error);
            });
        });
    },
    API_CheckCode(context, Code) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/checkcode', {
            "Code": Code,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },
    API_ChangeNote(context, PostData) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/cust_changenote', {
            "Phone": PostData.Phone,
            "Note": PostData.Note,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },

    API_ChangePass(context, PostData) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/user_changepass', {
            "oldPass": md5(PostData.oldPass),
            "newPass": md5(PostData.newPass),
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },

    API_ChangeStatus(context, Phone) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/changestatus', {
            "Phone": Phone,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },

    API_SabecoHistory(context, page) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/getsabecohistory', {
            "Page": page,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },
    API_BlockList(context, page) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/getblocklist', {
            "Page": page,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },
    API_CheckPhone(context, Phone) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/checkphone', {
            "Phone": Phone,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },
    API_Report(context, time) {
      //console.log(context.state.oUser.Token)
      if (context.state.oUser)
        return new Promise((resolve, reject) => {
          axios.post(Vue.prototype.$PRJ_DOMAIN + "/api" + '/getreport', {
            "Time": time,
            "Token": context.state.oUser.Token
          })
            .then(function (response) {
              //console.log(response);
              resolve(response)
              //PROCESS
            })
            .catch(function (error) {
              context.state.$message.error(
                "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
                3000, "bottom left"
              );
              reject(error)
              console.log(error);
            });
        });
    },
    // Socket_LoginToken(context) {
    //   return new Promise(() => {
    //     this._vm.$socket.client.emit(global.Users.LoginToken, JSON.stringify(context.getters.oUser), function (cb) {
    //       //xử lý call back
    //       console.log(cb);
    //       try {
    //         let Res = JSON.parse(cb);
    //         if (Res == null) {
    //           context.state.$message.error(
    //             "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
    //             3000, "bottom left"
    //           );
    //           return;
    //         }
    //         if (Res.status) {
    //           // console.log(router.currentRoute.path == "/Login")
    //           //   router.go("/")
    //           store.commit("Set_isLogin", true);
    //         }
    //         else {
    //           store.commit("Set_isLogin", false);
    //           context.state.$message.error(
    //             "Lỗi: Dữ liệu không chính xác, vui lòng báo Admin",
    //             3000
    //           );
    //         }
    //       }
    //       catch (err) {
    //         console.log("LoginToken err:" + err.message)
    //       }
    //     })
    //   });
    // },
    Go_Route(path) {
      router.go(path)
    }
  },
  modules: {
  }

});
export default store
import VueNumerals from 'vue-numerals';
import md5 from 'md5';

Vue.use(require('vue-moment'));
Vue.use(VueNumerals); // default locale is 'en'
Vue.use(FishUI)

// store.watch(
//   function (state) {
//     if(state.lstDevides){
//       state.lstDevides.forEach((oDevide)=>{
//         if(oDevide.is_active && oDevide.start_date)
//         {

//         }
//       })
//     }
//   },
// )
Vue.filter('toHHmm', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  return ("0" + Math.floor(value / 60)).slice(-2) + "h" + ("0" + value % 60).slice(-2);
});

Vue.filter('toNumber', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});
router.beforeEach((to, from, next) => {
  if (to.path != "/Login") {
    if (localStorage.getItem("isLogin") == "true") {
      next()
    }
    else next("/Login")
  }
  else {
    if (localStorage.getItem("isLogin") == "true") {
      next({ name: "Today", path: "/" })
    }
    else
      next()
  }
})
Vue.config.productionTip = false
new Vue({
  router,
  store: store,
  created() {
    store.commit("Set_Message", this.$message)
    store.commit("Set_isLogin", localStorage.getItem("isLogin"));
    // console.log(localStorage.getItem("isLogin"))
    // console.log(localStorage.getItem("oUser"))
    store.commit("Set_oUser", { oUser: JSON.parse(localStorage.getItem("oUser")) });
    store.dispatch("API_Getinfo")
  },
  mounted() {
  },
  data: {
    PRJ_START_DATE: "12000",
  },
  render: h => h(App),
  actions: {

  }
}).$mount('#app')